















































































import Vue from 'vue';
import { ScheduleEventDelayType } from '../../../models/ScheduleRuleContext';
import {
  ScheduleDelay,
  DelayMode,
  ScheduleDelayUnit,
} from '../../../models/ScheduleDelay';

import {ScheduleEventType} from '../../../models/ScheduleEventParam';

const delayType: ScheduleEventDelayType | undefined = undefined;
const time: string | undefined = undefined;


export default Vue.extend({
  props: {
    eventTriggered: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      delayType,
      ScheduleEventDelayType,
      ScheduleEventType,
      mAmount: 0,
      hAmount: 0,
      dAmount: 0,
      time,
    }
  },
  methods: {
    confirm() {
      if (this.validate()) {
        let delay: ScheduleDelay;
        if (this.delayType === ScheduleEventDelayType.InMinutes) {
          delay = {
            Fixed: {
              amount: this.mAmount,
              unit: ScheduleDelayUnit.Minute,
            },
          };
        } else if (this.delayType === ScheduleEventDelayType.InHours) {
          delay = {
            Fixed: {
              amount: this.hAmount,
              unit: ScheduleDelayUnit.Hour,
            },
          };
        } else if (this.delayType === ScheduleEventDelayType.InDays) {
          delay = {
            Nearest: {
              days: this.dAmount!,
              time: this.time!,
            },
          };
        } else {
          delay = {
            Fixed: {
              amount: 0,
              unit: ScheduleDelayUnit.Minute,
            },
          };
        }
        this.$store.commit('UPDATE_SCHEDULE_DELAY', delay);
        this.$store.commit('UPDATE_EVENT_DELAY_MODE', DelayMode.UseTpl);
        this.$emit('close');
      }
    },
    validate() {
      if (this.delayType === ScheduleEventDelayType.InMinutes &&
          this.mAmount < 1) {
        this.$Message.warning('请填写正确的分钟数');
        return false;
      } else if (this.delayType === ScheduleEventDelayType.InHours &&
                 this.hAmount < 1) {
        this.$Message.warning('请填写正确的小时数');
        return false;
      } else if (this.delayType === ScheduleEventDelayType.InDays) {
        if (this.dAmount < 1) {
          this.$Message.warning('请填写正确的天数');
          return false;
        } else if (!this.time) {
          this.$Message.warning('请选择时间');
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    initEventTriggered() {
      if (this.eventTriggered.delay) {
        const etd = JSON.parse(JSON.stringify(this.eventTriggered));
        if (etd.delay.Fixed) {
          if (etd.delay.Fixed.amount === 0) {
            this.delayType = ScheduleEventDelayType.RightNow;
          } else if (etd.delay.Fixed.unit === ScheduleDelayUnit.Minute) {
            this.delayType = ScheduleEventDelayType.InMinutes;
            this.mAmount = etd.delay.Fixed.amount;
          } else if (etd.delay.Fixed.unit === ScheduleDelayUnit.Hour) {
            this.delayType = ScheduleEventDelayType.InHours;
            this.hAmount = etd.delay.Fixed.amount;
          } else {}
        } else {
          this.delayType = ScheduleEventDelayType.InDays;
          this.dAmount = etd.delay.Nearest.days;
          this.time = etd.delay.Nearest.time;
        }
      } else {
        this.delayType = ScheduleEventDelayType.RightNow;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initEventTriggered();
    });
  },
});
